// extracted by mini-css-extract-plugin
module.exports = {"base":"Header_base__2ud06","layout":"Header_layout__8FutJ"};
    if(module.hot) {
      // 1586964018210
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  